import moment from 'moment';
export default ({ showHiddenTicketblocks, hiddenTicketBlocks, filters, status }) => (acc, payment) => {
  // Parse filters
  const paymentDate = moment(payment.payedAt || payment.createdAt)
  const filterStart = filters?.startDate && moment(filters.startDate, "YYYY-MM-DDTHH:mm:ss")
  const filterEnd = filters?.endDate && moment(filters.endDate, "YYYY-MM-DDTHH:mm:ss")
  const filterChannel = filters?.channel && filters.channel.length > 0 && filters.channel;
  const filterTicketBlocks = filters?.ticketBlocks && filters.ticketBlocks.length > 0 && filters.ticketBlocks;

  // Apply Payments Filters
  if (filterStart && paymentDate.isBefore(filterStart)) return acc;
  if (filterEnd && paymentDate.isAfter(filterEnd)) return acc;
  if (filterChannel && !filterChannel.includes(calculateChannel(payment))) return acc;
  if (filters?.hideCourtesy && payment.paymentType === "COURTESY") return acc;
  if (status && payment.status !== status) return acc;

  // Apply Ticket Filters
  const tickets = payment.Ticket.filter((t) => {
    if (
      !showHiddenTicketblocks &&
      hiddenTicketBlocks.has(t?.TicketBlock?.id)
    )
      return false;

    if (filterTicketBlocks && !filterTicketBlocks.includes(t?.TicketBlock?.id)) return false;


    return true;
  });
  if (tickets.length) {
    acc.tickets.push(...tickets.map((t) => ({ ...t, Payment: payment })));
    acc.payments.push({ ...payment, Ticket: tickets });
  }
  return acc;
}

function calculateChannel(payment) {
  if (payment.paymentMethod === "POS") return "pos";
  if (payment.Seller) return "promoter";
  return "site";
}

